export const requestColor = "#34CEB2";
export const paidColor = "#F66761";
export const unpaidColor = "#6772E5";
